import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  TableProps,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Select,
} from "@chakra-ui/react";
import * as React from "react";
import { FiDelete, FiEdit2, FiXCircle } from "react-icons/fi";
import { IoArrowDown } from "react-icons/io5";
import { KYDEvent } from "@common/interfaces/KYDEvent";
import { Navigate, useNavigate } from "react-router-dom";
import { IKYDUser, KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { CognitoUser } from "amazon-cognito-identity-js";
import { KYDOrganizationFull } from "@common/interfaces/KYDOrganization";
import { KYDRole, KYDScope } from "@common/interfaces/ICognito";

export const AdminsTable = ({
  //onRemoveAdmin,
  onEditAdmin,
  loading,
  currentUser,
  users,
  scopes,
  ...props
}: {
  loading: any;
  //onRemoveAdmin: (userId: string) => void;
  onEditAdmin: (user: KYDOrganizationUser) => void;
  currentUser: KYDOrganizationUser | null;
  users: KYDOrganizationUser[];
  scopes: KYDScope[];
}) => {
  const nameForRole = (roleId: KYDRole["id"], roles: KYDRole[]) => {
    const role = roles.find((r) => r.id === roleId);
    if (!role && roleId === "OWNER") {
      return "Owner";
    }

    return role ? role.name : "Unknown";
  };

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Phone</Th>
          <Th>Email</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {users.map((member: KYDOrganizationUser) => (
          <Tr key={member.id}>
            <Td>
              <HStack spacing="3">
                <Box>
                  <Text fontWeight="medium">
                    {`${member.first_name} ${member.last_name} ${
                      currentUser &&
                      currentUser.phone_number === member.phone_number
                        ? " (You)"
                        : ""
                    }`}
                  </Text>
                </Box>
              </HStack>
            </Td>
            <Td>
              <Text color="muted">{member.phone_number}</Text>
            </Td>
            <Td>
              <Text color="muted">{member.email}</Text>
            </Td>

            <Td>
              <HStack spacing="1">
                {currentUser &&
                  currentUser.phone_number !== member.phone_number && (
                    <IconButton
                      isDisabled={loading.remove_admin}
                      isLoading={loading[member.id]}
                      onClick={() => onEditAdmin(member)}
                      icon={<FiEdit2 fontSize="1.25rem" />}
                      variant="ghost"
                      aria-label="Edit user"
                    />
                  )}
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
